module.exports = __webpack_public_path__ + "static/media/photo9.ca32b35e.jpg";